module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-19.8ee29063.png";